/* Pete's — Bundle child-line injector (Option 2).
 *
 * The standalone "Build Your Box" builder POSTs a single PRICED parent line to
 * /cart/add.js with _bundle / _bundle_main:'true' / "Flavor N" properties, but NO
 * real component line items. That means: no shippable line -> checkout skips the
 * address, and ShipFusion sees "no items" -> cancels.
 *
 * This interceptor catches that add, figures out which shapes/quantities were
 * picked, and appends the matching $0 "Bundle Component" variants as REAL,
 * shippable, real-SKU child lines (sharing the parent's _bundle id, and the
 * parent's selling_plan on subscriptions). Result: address is collected, the 3PL
 * gets fulfillable SKUs, total = parent price only (children are $0, no double).
 *
 * Price stays entirely on the parent -> exact prices + escalation untouched.
 * Reversible: delete this asset + its <script> include.
 *
 * NOTE: child selling_plan (subs) only works once the component products are
 * enrolled in the SUB & SAVE selling plan in Stay.AI; until then test ONE-TIME.
 */
(function () {
  if (window.__petesBundleChildInjector) return;
  window.__petesBundleChildInjector = true;

  var nativeFetch = window.fetch.bind(window);

  // $11.99 1-pack variant id  ->  { component: $0 component variant id, flavor, sku }
  var MAP = {
    '49721003802943': { component: 53960650621247, flavor: 'Spaghetti',           sku: 'spaghetti-lc-1ct-shopify' },
    '49720977588543': { component: 53960651505983, flavor: 'Penne',               sku: 'penne-lc-1ct-shopify' },
    '49720995381567': { component: 53960651538751, flavor: 'Rotini',              sku: 'rotini-lc-1ct-shopify' },
    '49719921606975': { component: 53960651571519, flavor: 'Elbows',              sku: 'elbows-lc-1ct-shopify' },
    '49720971002175': { component: 53960651604287, flavor: 'No Carb Spaghetti',   sku: 'spaghetti-k-1ct-shopify' },
    '49720942494015': { component: 53960651637055, flavor: 'Fettuccine',          sku: 'fettuccine-lc-1ct-shopify' },
    '49720960614719': { component: 53960651669823, flavor: 'Linguine',            sku: 'linguine-lc-1ct-shopify' },
    '53024000278847': { component: 53960651702591, flavor: 'Gnocchi Keto',        sku: 'gnocchi-keto-1ct-shopify' },
    '53024000540991': { component: 53960651735359, flavor: 'Gnocchi Pro',         sku: 'gnocchi-pro-1ct-shopify' },
    '53024000377151': { component: 53960651768127, flavor: 'Gnocchi Lite',        sku: 'gnocchi-lite-1ct-shopify' },
    '53349770297663': { component: 53960651800895, flavor: 'Lasagna',             sku: 'lasagna-lc-1ct-shopify' }
  };

  function isCartAdd(resource) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url);
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // Primary source: read selected quantities straight from the builder DOM,
  // keyed by the 1-pack variant id on each .product-item (no fragile string parsing).
  function readSelectionsFromDom() {
    var out = {};
    document.querySelectorAll('.product-item[data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      var disp = el.querySelector('.qty-display');
      var qty = disp ? parseInt((disp.textContent || '0').trim(), 10) : 0;
      if (vid && qty > 0) out[vid] = (out[vid] || 0) + qty;
    });
    if (!Object.keys(out).length) {
      document.querySelectorAll('bundle-product[data-product-id]').forEach(function (el) {
        var vid = el.getAttribute('data-product-id');
        var disp = el.querySelector('.product-count');
        var qty = disp ? parseInt((disp.textContent || '0').trim(), 10) : 0;
        if (vid && qty > 0) out[vid] = (out[vid] || 0) + qty;
      });
    }
    return out;
  }

  // Fallback: reconstruct from the parent line's "Flavor N" properties
  // ("<qty> x <name> 1 Pack"), mapping <name> -> variant id via the DOM headers.
  function readSelectionsFromFlavors(parent) {
    var nameToVariant = {};
    document.querySelectorAll('.product-item[data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      var hdr = el.querySelector('.bb-product-header');
      if (vid && hdr) nameToVariant[(hdr.textContent || '').trim().toLowerCase()] = vid;
    });
    document.querySelectorAll('bundle-product[data-product-id]').forEach(function (el) {
      var vid = el.getAttribute('data-product-id');
      var nm = el.getAttribute('data-product-flavor');
      if (vid && nm) nameToVariant[nm.trim().toLowerCase()] = vid;
    });
    var out = {};
    var props = parent.properties || {};
    Object.keys(props).forEach(function (k) {
      if (k.indexOf('Flavor') !== 0) return;
      var m = String(props[k]).match(/^\s*(\d+)\s*x\s*(.+?)\s*1\s*pack\s*$/i);
      if (!m) return;
      var qty = parseInt(m[1], 10);
      var vid = nameToVariant[m[2].trim().toLowerCase()];
      if (vid && qty > 0) out[vid] = (out[vid] || 0) + qty;
    });
    return out;
  }

  function buildChildren(parent) {
    // Flavor props are written from the builder's APP STATE and are authoritative.
    // DOM counts can be stale (deselected tiles keep their last .product-count) -> only a fallback.
    var sel = readSelectionsFromFlavors(parent);
    if (!Object.keys(sel).length) sel = readSelectionsFromDom();

    var bundleId = (parent.properties || {})._bundle;
    var plan = parent.selling_plan;
    var children = [];
    Object.keys(sel).forEach(function (vid) {
      var m = MAP[vid];
      if (!m) return; // shape has no component mapped -> skip (don't break the add)
      var child = {
        id: m.component,
        quantity: sel[vid],
        properties: { _bundle: bundleId, flavor: m.flavor, sku: m.sku }
      };
      if (plan) child.selling_plan = Number(plan);
      children.push(child);
    });
    return children;
  }

  window.fetch = function (resource, init) {
    try {
      if (!init || !isCartAdd(resource) || typeof init.body !== 'string') return nativeFetch(resource, init);

      var payload = JSON.parse(init.body);
      if (!payload || !Array.isArray(payload.items)) return nativeFetch(resource, init);

      // the standalone bundle parent line
      var parent = payload.items.filter(function (it) {
        return it.properties && (it.properties._bundle_main === 'true' || it.properties._bundle_main === true);
      })[0];
      if (!parent) return nativeFetch(resource, init);

      // already have component children? don't double-inject
      var hasChildren = payload.items.some(function (it) {
        return it.properties && it.properties._bundle && !(it.properties._bundle_main === 'true' || it.properties._bundle_main === true);
      });
      if (hasChildren) return nativeFetch(resource, init);

      var children = buildChildren(parent);
      if (!children.length) return nativeFetch(resource, init);

      var next = {};
      for (var key in payload) next[key] = payload[key];
      next.items = payload.items.concat(children);

      var initNext = {};
      for (var ik in init) initNext[ik] = init[ik];
      initNext.body = JSON.stringify(next);

      return nativeFetch(resource, initNext);
    } catch (e) {
      return nativeFetch(resource, init);
    }
  };
})();
